import { render } from "./LandingPage.vue?vue&type=template&id=0cfbf7be&scoped=true"
import script from "./LandingPage.vue?vue&type=script&lang=js"
export * from "./LandingPage.vue?vue&type=script&lang=js"

import "./LandingPage.vue?vue&type=style&index=0&id=0cfbf7be&lang=css"
import "./LandingPage.vue?vue&type=style&index=1&id=0cfbf7be&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cfbf7be"]])

export default __exports__